/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useContext } from "react";
import { initialContext, ContextUpdater } from "../Context";
import { useNavigate } from "react-router-dom";
import { Navbar, Button, Label } from "reactstrap";
import packageJson from '../../package.json'

import smartWifiLogo from "../assets/images/sw_logo.svg";
import smartWifiIcon from "../assets/images/sw_icon.svg";
import { customDomainLogo, isCustomDomain } from "../util/CustomDomain";

const Header = () => {
  // context
  const contextUpdater = useContext(ContextUpdater);

  // navigator
  const navigate = useNavigate()

  // handlers
  const handleLogout = () => {
    contextUpdater({ ...initialContext });
    navigate("/login")
  };

  return (
    <Navbar className="d-flex justify-content-between" color="secondary-background" style={{ padding: "0" }}>
      {isCustomDomain() ? (
          <div className="d-flex">
            <img src={customDomainLogo()} alt="" style={{ height: "50px" }} />
          </div>
        ) : (
          <div className="d-flex">
            <img src={smartWifiLogo} alt="" style={{ height: "36px" }} />
            <img src={smartWifiIcon} alt="" style={{ height: "36px" }} />
          </div>
        )
      }
      <div>
      <div className="py-2 d-flex align-items-center" style={{ flexDirection: "column" }}>
        <Button size="sm" color="dark" outline onClick={handleLogout}>Logout</Button>
        <Label className="no-spacing text-muted" size="sm">v{packageJson.version}</Label>
      </div>
      </div>
    </Navbar>
  );
};

export default Header;